export default "__VITE_ASSET__DAHTbQ$p__"